import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';
import Cookies from 'universal-cookie';

// components
import Header from "../Header/Header";
import Sidebar from "../Sidebar";

// pages
import UserProfile from "../../pages/userprofile";
import MenuPage from "../../pages/menupage";
import Notifications from "../../pages/notifications";
import AddInvestor from "../../pages/addInvestor";
import AddAnalyst from "../../pages/addAnalyst";
import AddCompany from "../../pages/addCompany";
import Stats from "../../pages/stats";
import MasterPage from "../../pages/masterPage";

import EditCompany from "../../pages/editCompany";
import EditCompanyBroker from "../../pages/editCompanyBroker";
import EditInvestor from "../../pages/editInvestor";
import EditAnalyst from "../../pages/editAnalyst";
import EditIntermediary from "../../pages/editIntermediary";

import EventsList from "../../pages/eventslist";
import UsersList from "../../pages/userslist";
import AddUser from "../../pages/adduser";
import AdminSettings from "../../pages/adminsettings";
import CreateEvent from "../../pages/createEvent";
import UserSettings from "../../pages/usersettings";
import MailQueue from "../../pages/mailqueue";
import EventDetails from "../../pages/eventdetails";
import Intermediaries from "../../pages/intermediaries";
import Investors from "../../pages/investors";
import Analysts from "../../pages/analysts";
import Companies from "../../pages/companies";
import Schedule from "../../pages/schedule";

import InvestorsBroker from "../../pages/investorsBroker";
import AnalystsBroker from "../../pages/analystsBroker";
import CompaniesBroker from "../../pages/companiesBroker";
import StatsBroker from "../../pages/statsBroker";

import PdfPage from "../../pages/pdfPage";
import ExcelPage from "../../pages/excelPage";

import AddIntermediary from "../../pages/addIntermediary";

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class Layout extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menuItems: []
    }
  }

  async componentDidMount(){

    const cookies = new Cookies();
    const appId = cookies.get('appId', { path: '/' });
//    const resp = await getSection(appId, 'Menu');

//    const json = JSON.parse(resp).result;

    //alert(JSON.stringify(json))
 //   this.setState({menuItems: JSON.parse(json)});
  }


  render (){

    // global
    const { classes } = this.props;
    
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const userType = cookies.get('userType', { path: '/' });

    return (
      <div className={classes.root}>
          <>
            <Header history={this.props.history} />
            <Sidebar menuItems={this.state.menuItems}/>
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />
              {userType == 2 ?
                <Route path="/app/adminsettings" component={AdminSettings} />
              : null }
              { username == 'admin' ? 
              <Switch>
                <Route path="/app/accountslist" component={UsersList} />
                <Route path="/app/addaccount" component={AddUser} />
                <Route path="/app/adminsettings" component={AdminSettings} />
              </Switch> :
              <Switch>
                <Route path="/app/companiesBroker" component={CompaniesBroker} />
                <Route path="/app/investorsBroker" component={InvestorsBroker} />
                <Route path="/app/analystsBroker" component={AnalystsBroker} />
                <Route path="/app/statsBroker" component={StatsBroker} />

                <Route path="/app/userProfile" component={UserProfile} />
                <Route path="/app/menu" component={MenuPage} />
                <Route path="/app/notifications" component={Notifications} />

                <Route path="/app/eventslist" component={EventsList} />
                <Route path="/app/newevent" component={CreateEvent} />
                <Route path="/app/usersettings" component={UserSettings} />
                <Route path="/app/mailqueue" component={MailQueue} />
                
                <Route path="/app/eventdetails" component={EventDetails} />
                <Route path="/app/intermediaries" component={Intermediaries} />
                <Route path="/app/investors" component={Investors} />
                <Route path="/app/analysts" component={Analysts} />
                <Route path="/app/companies" component={Companies} />
                <Route path="/app/schedule" component={Schedule} />
                <Route path="/app/master" component={MasterPage} />

                <Route path="/app/stats" component={Stats} />
                
                <Route path="/app/newintermediary" component={AddIntermediary} />
                <Route path="/app/addinvestor" component={AddInvestor} />
                <Route path="/app/addanalyst" component={AddAnalyst} />
                <Route path="/app/addcompany" component={AddCompany} />

                <Route path="/app/editcompany" component={EditCompany} />
                <Route path="/app/editcompanybroker" component={EditCompanyBroker} />
                <Route path="/app/editintermediary" component={EditIntermediary} />
                <Route path="/app/editinvestor" component={EditInvestor} />
                <Route path="/app/editanalyst" component={EditAnalyst} />
                <Route path="/app/pdfPage" component={PdfPage} />
                <Route path="/app/excelPage" component={ExcelPage} />

                <Route
                  exact
                  path="/app/ui"
                  render={() => <Redirect to="/app/ui/icons" />}
                />
              </Switch>
            }
            </div>
            <div
              className={classnames(classes.contentPhone)}
            >
            </div>
          </>
      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(Layout));
